import { compose, hoistStatics, lifecycle, withProps, withState } from 'recompose';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Blog from './Blog';
import WithLoading from '../../../components/WithLoading';
import ModuleService from '../../../services/module.service';
import { settingsActions } from '../../../reducers/settings';
import Loading2 from "../../../components/Loading2";

const mapStateToProps = state => ({
  modulesSettings: state.modules.modulesSettings,
});

const mapDispatchToProps = {
  updateSettings: settingsActions.updateSettings,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  translate('portal'),
  withState('isLoading', 'setIsLoading', false),
  lifecycle({
    componentDidMount() {
      this.props.updateSettings({ hasLoadedPage: true });
    },
  }),
  withProps(props => ({
    moduleTitle: props.modulesSettings[ModuleService.TYPE_BLOG].title || props.t('Blog'),
    backgroundColor: props.modulesSettings[ModuleService.TYPE_BLOG].color ?
      props.modulesSettings[ModuleService.TYPE_BLOG].color : props.modulesSettings[ModuleService.TYPE_BLOG].default_color,
    backgroundCover: props.modulesSettings[ModuleService.TYPE_BLOG].cover,
    enableCoverColor: props.modulesSettings[ModuleService.TYPE_BLOG].enable_cover_color,
  })),
);

export default withRouter(hoistStatics(enhance)(WithLoading(Blog, Loading2)));



// WEBPACK FOOTER //
// ./src/views/modules/blog/index.js